import React from 'react';
import MakeTemplate from '../MakeTemplate';
import SiteTransfer from '../SiteTransfer';
import SiteConfig from '../SiteConfig';
import SiteDelete from '../SiteDelete';

function SiteModals({ modal, ...rest }) {
    const { site } = rest;
    return (
        <>
            {modal === 'SITE_CONFIG' && <SiteConfig {...rest} />}
            {modal === 'TRANSFER' && <SiteTransfer {...rest} />}
            {modal === 'DELETE' && !!site && <SiteDelete {...rest} />}
            {modal === 'MAKE_TEMPLATE' && <MakeTemplate {...rest} />}
        </>
    );
}

export default SiteModals;
